const validatePage1 = async (values, showAddress, isEdit) => {
    const currentDate = new Date().toISOString().slice(0, 10);
    let date1 = new Date(currentDate);
    let date2 = new Date(values.fechaNacimiento);
    let diferenciaMs = date1 - date2;
    let diferenciaAnios = Math.floor(
        diferenciaMs / (1000 * 60 * 60 * 24 * 365.25)
    );

    let dateFechaExpedición = new Date(values.expediciónCédula);
    let dateFechaNacimiento = new Date(values.fechaNacimiento);
    let diferenciaMsDate = dateFechaExpedición - dateFechaNacimiento;
    let diferenciaDate = diferenciaMsDate / (1000 * 60 * 60 * 24 * 365.25);

    const errors = {};

    if (!values.tipoGestor) {
        errors.tipoGestor = "Este campo es requerido. Seleccione una opción";
    }
    if (!values.primerNombre) {
        errors.primerNombre = "Este campo es requerido";
    }
    if (values.primerNombre && values.primerNombre.length > 50) {
        errors.primerNombre =
            "El primer nombre no debe contener más de 50 caracteres.";
    }
    if (values.segundoNombre && values.segundoNombre.length > 50) {
        errors.segundoNombre =
            "El segundo nombre no debe contener más de 50 caracteres.";
    }
    if (!values.primerApellido) {
        errors.primerApellido = "Este campo es requerido";
    }
    if (values.primerApellido && values.primerApellido.length > 50) {
        errors.primerApellido =
            "El primer apellido no debe contener más de 50 caracteres.";
    }
    if (values.segundoApellido && values.segundoApellido.length > 50) {
        errors.segundoApellido =
            "El segundo apellido no debe contener más de 50 caracteres.";
    }
    if (!values.tipoIdentificación) {
        errors.tipoIdentificación =
            "Este campo es requerido, por favor seleccione su identificación";
    }
    if (!values.numeroIdentificación) {
        errors.numeroIdentificación = "Este campo es requerido";
    } else {
        localStorage.setItem("documento", values.numeroIdentificación);
    }
    if (values?.numeroIdentificación?.length > 10) {
        errors.numeroIdentificación =
            "El número de identificación debe de tener máximo 10 dígitos.";
    }
    if (values?.numeroIdentificación?.length < 6) {
        errors.numeroIdentificación =
            "El número de identificación debe de tener mínimo 6 dígitos.";
    }
    if (!values.expediciónCédula) {
        errors.expediciónCédula =
            "Este campo es requerido, por favor seleccione una fecha";
    }
    if (values.expediciónCédula) {
        if (diferenciaDate < 17.998) {
            errors.expediciónCédula =
                "Tu fecha de expedición de la cédula debe ser mayor que tu fecha de nacimiento minino 18 años";
        }
    }
    if (!values.sexo) {
        errors.sexo = "Este campo es requerido, por favor seleccione el sexo al nacer";
    }
    if (!values.genero) {
        errors.genero = "Este campo es requerido, por favor seleccione el genero";
    }
    if (!values.fechaNacimiento) {
        errors.fechaNacimiento =
            "Este campo es requerido, por favor seleccione una fecha";
    }
    if (values.fechaNacimiento) {
        if (diferenciaAnios < 18) {
            errors.fechaNacimiento =
                "Debes ser mayor de 18 años para poder continuar con tu tramite";
        }
    }
    if (!values.municipioNacimiento) {
        errors.municipioNacimiento = "Este campo es requerido";
    }
    if (!values.departamentoNacimiento) {
        errors.departamentoNacimiento = "Este campo es requerido";
    }
    if (!values.grupoÉtnico) {
        errors.grupoÉtnico =
            "Este campo es requerido, seleccione un grupo étnico";
    }
    if (values?.grupoÉtnico?.id === 301) {
        if (!values.comunidadIndígena) {
            errors.comunidadIndígena =
                "Este campo es requerido, seleccione una comunidad indígena";
        }
    }
    if (values?.comunidadIndígena?.id === 27) {
        if (!values.cualComunidadIndígena) {
            errors.cualComunidadIndígena =
                "Este campo es requerido, indique cuál comunidad indígena";
        }
    }
    if (!values.departamentoResidencia) {
        errors.departamentoResidencia = "Este campo es requerido";
    }
    if (!values.municipioResidencia) {
        errors.municipioResidencia = "Este campo es requerido";
    }
    if (!values.tiempoResidencia) {
        errors.tiempoResidencia = "Este campo es requerido";
    }
    if (!values.localidad) {
        errors.localidad = "Este campo es requerido, indique su localidad";
    }
    if (!values.zona) {
        errors.zona = "Este campo es requerido, seleccione una zona";
    }
    if (values.zona?.id === 223) {
        if (!values.direcciónZonaRural) {
            errors.direcciónZonaRural =
                "Este campo es requerido, indique su dirección";
        }
    }
    if (!values.sector) {
        errors.sector = "Este campo es requerido, indique el sector";
    }
    if (values.zona?.id === 224) {
        if (!values.barrio) {
            errors.barrio = "Este campo es requerido, indique su barrio";
        }
    }
    if (!isEdit || (isEdit && !showAddress)) {
        if (values.zona?.id === 224) {
            if (!values.via) {
                errors.via = "Este campo es requerido, indique la via";
            }
        }
        if (values.zona?.id === 224) {
            if (!values.numeroVia) {
                errors.numeroVia = "Este campo es requerido, indique la via";
            }
        }
        if (values.zona?.id === 224) {
            if (!values.numeroViaGeneradora) {
                errors.numeroViaGeneradora =
                    "Este campo es requerido, indique la via generadora";
            }
        }
    }

    return errors;
};

export default validatePage1;
